import { Select } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Select)`
  & > .MuiSelect-select {
    display: flex;
    align-items: center;
    height: 100%;
    padding-right: ${(p) => p.theme.spacing(2)}!important;
  }

  &.Mui-disabled {
    .MuiSelect-icon {
      display: none;
    }

    * {
      cursor: not-allowed;
    }
  }
`;

export const Placeholder = styled('span')`
  color: ${(p) => p.theme.palette.text.disabled};
`;
